import { Link } from "react-router-dom";

const linkCls = "hover:text-[#4A6B53] hover:underline transition-colors";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-[#E5DCD0] bg-[#F2EBE1]">
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img
              src="/logo-agrigiochiamo.gif"
              alt="Agrigiochiamo Network"
              className="h-12 w-auto rounded-xl"
            />
            <span className="font-display font-black text-lg text-[#2C312E]">
              Agri<span className="text-[#C8795A]">Giochi</span><span className="text-[#4A6B53]">Amo</span>
            </span>
          </div>
          <p className="text-sm text-[#58625B] leading-relaxed max-w-xs">
            Il Network nazionale di realtà educative in natura,
            per scuole e famiglie che credono nell&apos;apprendimento all&apos;aria aperta.
          </p>
        </div>
        <div>
          <h4 className="font-display font-extrabold text-[#2C312E] mb-3">Esplora</h4>
          <ul className="space-y-2 text-sm text-[#58625B]">
            <li><Link to="/fattorie" className={linkCls} data-testid="footer-link-farms">Tutte le fattorie</Link></li>
            <li><Link to="/fattorie" className={linkCls} data-testid="footer-link-activities">Tipologie di attività</Link></li>
            <li><Link to="/fattorie?near=me" className={linkCls} data-testid="footer-link-nearby">Vicino a te</Link></li>
            <li><Link to="/fattorie?activity=campi-estivi" className={linkCls} data-testid="footer-link-camps">Campi estivi</Link></li>
            <li><Link to="/progetti" className={linkCls} data-testid="footer-link-projects">Progetti</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-extrabold text-[#2C312E] mb-3">Network</h4>
          <ul className="space-y-2 text-sm text-[#58625B]">
            <li><Link to="/chi-siamo" className={linkCls} data-testid="footer-link-about">Chi siamo</Link></li>
            <li><Link to="/chi-siamo#manifesto" className={linkCls} data-testid="footer-link-manifesto">Il Manifesto</Link></li>
            <li><Link to="/adesione" className={linkCls} data-testid="footer-link-join">Unisciti al Network</Link></li>
            <li><Link to="/segnala" className={linkCls} data-testid="footer-link-suggest">Segnala una realtà</Link></li>
            <li>
              <a href="mailto:info@agrigiochiamo.it" className={linkCls} data-testid="footer-link-contact">
                Contatti
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E5DCD0] py-6 text-center text-xs font-semibold tracking-wider uppercase text-[#7A7369]">
        © {new Date().getFullYear()} Network Agrigiochiamo — Educazione in natura
      </div>
    </footer>
  );
}
